import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import SearchSelect from "Components/molecule/inputs/search-select"
import TextInput from "Components/molecule/inputs/text-input"
import { SelectOption } from "Components/molecule/inputs/select-input"
import useEnterSearch from "hooks/useEnterSearch"
import { IEmergencyContactQueryParams } from "models/emergency-contact"

interface SearchEmergencyContactProps {
    handleChangeQuery: (key: keyof IEmergencyContactQueryParams, value: any) => any,
    handleClearSearch: () => any,
    handleSearch: () => any,
    divisions: SelectOption[],
    departments: SelectOption[],
    provinces: SelectOption[],
    query: IEmergencyContactQueryParams
    isSearching: boolean
}

const SearchEmergencyContact = ({
    handleChangeQuery,
    handleClearSearch,
    handleSearch,
    divisions,
    departments,
    provinces,
    query,
    isSearching
}: SearchEmergencyContactProps) => {

    const { inputProps, selectProps } = useEnterSearch(handleSearch)

    return (
        <SearchFormContainer
            inputs={
                <>
                    <TextInput
                        label="Employee Name"
                        placeholder="Search employee..."
                        value={query.employeeName ?? ''}
                        onChange={(e) => handleChangeQuery('employeeName', e.target.value)}
                        {...inputProps}
                    />
                    <TextInput
                        label="Contact Name"
                        placeholder="Search contact..."
                        value={query.contactName ?? ''}
                        onChange={(e) => handleChangeQuery('contactName', e.target.value)}
                        {...inputProps}
                    />
                    <SearchSelect
                        label="Division"
                        options={divisions}
                        value={query.division ?? ''}
                        onChange={(e) => handleChangeQuery('division', e?.value || undefined)}
                        {...selectProps}
                    />
                    <SearchSelect
                        label="Department"
                        options={departments}
                        value={query.department ?? ''}
                        onChange={(e) => handleChangeQuery('department', e?.value || undefined)}
                        {...selectProps}
                    />
                    <SearchSelect
                        label="Location"
                        options={provinces}
                        value={query.province ?? ''}
                        onChange={(e) => handleChangeQuery('province', e?.value || undefined)}
                        {...selectProps}
                    />
                </>
            }
            clearSearchButton={
                <>
                    <PrimaryButton
                        style={{
                            minWidth: '150px'
                        }}
                        disabled={isSearching}
                        onClick={handleSearch}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{
                            minWidth: '100px'
                        }}
                        disabled={isSearching}
                        onClick={handleClearSearch}
                    >
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )
}

export default SearchEmergencyContact
